// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Q6H33","selected":"style_selected__1PHzS","heading":"style_heading__1RY5Z","name":"style_name__3c_HH","description":"style_description__35l6i"};